import { ReservationSource } from './get'


// Список пишется целиком: позиция величина относительная, и перенос одного канала
// меняет позиции соседям. Первым элементом обязан идти закреплённый канал.
export type UpdateReservationSourcesReq = { items: number[] }
export type UpdateReservationSourcesRes = ReservationSource[]

export const UPDATE_RESERVATION_SOURCES = '/v2/pms/reservation-sources/'
